import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import ImageUploading from "react-images-uploading";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
	errorMessage: {
		color: "red",
		marginTop: theme.spacing(2),
	},

	uploadButton: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		"&:hover": {
			backgroundColor: theme.palette.primary.dark,
		},
	},
}));

const BannerUploader = ({
	handleImageUpload,
	image,
	setImageURL,
	handleDeleteImg,
	errorMes,
}) => {
	const classes = useStyles();
	const [images, setImages] = useState([]);
	const [uploading, setUploading] = useState(false);
	const { t } = useTranslation();

	const [localError, setLocalError] = useState("");

	const maxNumber = 1; // Максимальное количество изображений
	const maxFileSize = 512000; // Максимальный размер файла 500 KB
	const maxAcceptType = ["jpg", "jpeg", "png"];

	useEffect(() => {
		if (image) {
			setImages([{ dataURL: image }]);
		}
	}, [image]);

	const handleUpload = async (imageList) => {
		if (imageList.length > 0) {
			const file = imageList[0].file;
			if (file) {
				setUploading(true);
				setLocalError("");
				try {
					await handleImageUpload({ file });
					setLocalError("");
					// Здесь можно передать URL в родительский компонент, если нужно
				} catch (error) {
					console.error("Error uploading image:", error);
					setLocalError("Ошибка при загрузке изображения.");
				} finally {
					setUploading(false);
				}
			}
		}
	};

	const handleUploadError = (errors) => {
		if (errors.maxFileSize) {
			setLocalError("Файл слишком большой. Максимальный размер — 500KB.");
		} else if (errors.acceptType) {
			setLocalError(
				"Неподдерживаемый формат файла. Разрешены: JPG, JPEG, PNG."
			);
		} else {
			setLocalError("Ошибка загрузки изображения.");
		}
	};

	const handleDelete = async (img) => {
		// Вызываем функцию удаления изображения из родительского компонента
		const name = img.split("/").pop();
		await handleDeleteImg({ id: Date.now(), name });
		setImageURL("");
		// Очищаем текущее изображение в BannerUploader
		setImages([]);
	};

	return (
		<div>
			<Typography variant="h6">{t("labels.addImgTitle")}</Typography>

			<ImageUploading
				multiple={false}
				value={images}
				onChange={(imageList) => {
					setImages(imageList);
					handleUpload(imageList); // Передаем выбранные изображения в родительский компонент
				}}
				maxNumber={maxNumber}
				maxFileSize={maxFileSize}
				acceptType={maxAcceptType}
				onError={handleUploadError}
			>
				{({
					imageList,
					onImageUpload,
					onImageRemove,
					isDragging,
					dragProps,
				}) => (
					<div>
						<Button
							className={classes.uploadButton}
							onClick={onImageUpload}
							{...dragProps}
						>
							{t("labels.addImg")}
						</Button>
						{imageList.length > 0 && (
							<div style={{ marginTop: 20 }}>
								{imageList.map((image, index) => (
									<div key={index} style={{ marginBottom: 10 }}>
										<img src={image.dataURL} alt="" width="100" />
										<Button
											variant="contained"
											color="secondary"
											onClick={() => handleDelete(image.dataURL)}
											style={{ marginLeft: 10 }}
										>
											{t("buttons.delete")}
										</Button>
									</div>
								))}
							</div>
						)}
					</div>
				)}
			</ImageUploading>

			{(errorMes || localError) && (
				<Typography className={classes.errorMessage}>
					{errorMes || localError}
				</Typography>
			)}

			{images.length > 0 && (
				<Chip label={t("labels.readyToSave")} style={{ marginTop: 20 }} />
			)}
		</div>
	);
};

export default BannerUploader;
